import axios from 'axios'
import Error from '../kne/error'
import { IEnvironment, IEnvironmentAddRequest, IEnvironmentDeleteRequest } from '../model/Environment'

export default class EnvironmentService {

    getAllEnvironments(): Promise<IEnvironment[]> {
        return new Promise((resolve, reject) => {
            axios.get('/api/admin/GetAllEnvironments').then(res => {
                resolve(res.data)
            }, (err: Error) => {
                console.error(err)
                reject(err)
            })
        })
    }

    addNewEnvironment(addRequest: IEnvironmentAddRequest): Promise<IEnvironment> {
        return new Promise((resolve, reject) => {
            axios.post('/api/admin/AddNewEnvironment', addRequest).then(res => {
                resolve(res.data)
            }, (err: Error) => {
                console.error(err)
                reject(err)
            })
        })
    }

    deleteEnvironment(deleteRequest: IEnvironmentDeleteRequest): Promise<boolean> {
        return new Promise((resolve, reject) => {
            axios.post('/api/admin/DeleteEnvironment', deleteRequest).then(res => {
                resolve(res.data)
            }, (err: Error) => {
                console.error(err)
                reject(err)
            })
        })
    }
}